import cx from "classnames";
import { Link, useMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import {
    HomeIcon,
    IdentificationIcon,
    CursorArrowRaysIcon,
    ChatBubbleBottomCenterTextIcon,
    DocumentTextIcon,
    ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";
import {generate} from "../../../routing/routes";
import { useTranslation } from "react-i18next";
import * as customerTypes from "../../../data/booking/constants/customer_types";

const navigation = [
    {
        id: "home",
        name: 'account_button.dashboard',
        route: 'account_dashboard',
        icon: HomeIcon
    },
    {
        id: "informations",
        name: 'account_button.my_account',
        route: 'account_informations',
        icon: IdentificationIcon,
    },
    {
        id: "reservations",
        name: 'account_button.reservations',
        route: 'account_reservations',
        icon: CursorArrowRaysIcon,
        type: "business"
    },
    {
        id: "quotations",
        name: 'account_button.quotations',
        route: 'account_quotations',
        icon: ChatBubbleBottomCenterTextIcon,
        type: "business"
    },
    {
        id: "invoices",
        name: 'account_button.invoices',
        route: 'account_invoices',
        icon: DocumentTextIcon,
        type: "business"
    },
    {
        id: "documents",
        name: 'account_button.documents',
        route: 'account_documents',
        icon: ClipboardDocumentListIcon,
        type: "business"
    },
];

export default function Navigation() {
    const { t } = useTranslation();
    const { data } = useSelector(state => state.account.userSession);

    const userSessionBusiness = () => {
        return customerTypes.BUSINESS === data.type
    };

    const filteredNavigation = userSessionBusiness()
        ? navigation
        : navigation.filter(item => item.type !== "business");
    
    return (
        <nav className="space-y-1 px-2">
            {filteredNavigation.map((item) => {
                const href = generate(item.route)
                const currentPage = useMatch(href)
                return <Link
                    key={item.name}
                    to={href}
                    className={cx(
                        null !== currentPage
                            ? "bg-gray-100 text-orange-500"
                            : "text-gray-600 hover:bg-gray-50 hover:text-orange-500",
                        "group flex items-center rounded-md py-2 px-2 text-sm font-medium"
                    )}
                >
                    <item.icon
                        className={cx(
                            null !== currentPage
                                ? "text-orange-400"
                                : "text-gray-400 group-hover:text-gray-500",
                            "mr-4 h-6 w-6 flex-shrink-0"
                        )}
                        aria-hidden="true"
                    />
                    {t(item.name)}
                </Link>
            })}
        </nav>
    );
}
